<script>
    import { imageUserDefault } from '@/helpers'
    import useStore from '@/hooks/useStore'
    import CloseButton from '@/components/webchat/CloseButton.vue'

    export default {
        components: { CloseButton },
        props: {
            photo: {
                type: String,
                default: imageUserDefault
            },

            name: {
                type: String,
                default: 'Atendimento'
            },
            close:{
                type: Boolean,
                default: false
            },
            company: {
                type: String,
                default: 'Em andamento'
            }
        },

        emits: ['close-box'],

        setup (_, { emit }) {
            const store = useStore()

            return {
                store,
                emit
            }
        }
    }
</script>

<template>
    <div
        class="relative flex items-center w-full p-2"
        :style="`background-color: ${store.data?.bgColor}`"
    >
        <CloseButton
            v-if="!close"
            @close-box="() => emit('close-box')"
            class='right-2 top-1'
        />

        <div class="p-0.5 rounded-full border-2 border-white w-12 overflow-hidden">
            <img
                :src="photo"
                :alt="name"
                class="w-full rounded-full"
            >
        </div>

        <div class="flex flex-col text-white px-2">
            <p class="text-sm font-medium font-rubik"> {{ name }} </p>
            <span class="text-xs opacity-60">{{ company }}</span>
        </div>
    </div>
</template>
